export default function getSessionConfNumber() {
  return {
    hardLoggedin: false,
    sesionConfirmationNumber: '847949249212593839',
  };
}
